import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import useConditionalSubmit from '../../../../../hooks/useConditionalSubmit';
import { getGiftGl } from '../../../store/data/data.selectors';
import { getIsPreview } from '../../../store/statuses/statuses.selectors';
import StyledSecondaryButton from '../../../../../components/Shared/StyledSecondaryButton';

export interface IExchangeButtonProps {
  onSubmit: (useDonation: boolean) => void;
}

const ExchangeButton = ({ onSubmit }: IExchangeButtonProps): JSX.Element => {
  const gl = useSelector(getGiftGl);
  const isPreview = useSelector(getIsPreview);
  const submitHandler = useConditionalSubmit(!isPreview, onSubmit);

  return (
    <StyledSecondaryButton data-testid="giftExchangeButton" onClick={submitHandler}>
      Exchange your {gl}
    </StyledSecondaryButton>
  );
};

export default memo<IExchangeButtonProps>(ExchangeButton);
